export default {"src":"/_next/static/media/fj.05d0d516.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};